import { useTranslation } from 'react-i18next';
import { FixedCtaBanner } from 'components/FixedBanner';
import { routes } from 'router/routes';

export const AssignmentPreviewWarningBanner = () => {
  const { t } = useTranslation();

  return (
    <FixedCtaBanner buttonText={t('assignments.preview.warning.cta')} to={routes.homePractice}>
      {t('assignments.preview.warning.title')}
    </FixedCtaBanner>
  );
};
